import React from "react";
import { useForceRender } from "./useForceRender.js";
/**
 * Utility that subscribes to events and forces a rerender
 *
 * downstream consumers must track the properties that will change
 * as the event target object itself doesnt change.
 */
export const useEventTargetSubscription = (target, eventName) => {
  const forceRender = useForceRender();
  React.useEffect(() => {
    target.addEventListener(eventName, forceRender);
    return () => {
      target.removeEventListener(eventName, forceRender);
    };
  }, []);
  return target;
};